/**
 * What the numbers being typed would do to a real order.
 *
 * Changing the platform's cut from a flat 100 TZS to a percentage is a
 * decision worth checking before it is saved, not after the next order — so
 * the editor works the sums out from whatever is on screen.
 *
 * These mirror the backend's own split (services/payment_service.py) and the
 * delivery pricing both apps use. They are only for showing an example; the
 * money itself is always worked out server-side.
 */

/** What Beetle keeps from an order of [orderTotal] TZS of goods. */
export function platformCut(type, value, orderTotal) {
  const amount = Number(value) || 0;
  const total = Number(orderTotal) || 0;
  if (type === 'percentage') return Math.round(total * amount / 100);
  return Math.round(amount);
}

/**
 * What a [km]-kilometre delivery costs the buyer: the base fee plus distance,
 * never less than the minimum charge.
 */
/**
 * What one delivery costs on a given vehicle: sending it out, the journey,
 * and the load — never below the minimum charge.
 *
 * This is both what the buyer pays and what the driver is offered, which is
 * the point of keeping one rate per vehicle.
 */
export function deliveryOn({ baseFee, perKm, perKg, km, weightKg, minFee }) {
  const total = buyerDeliveryCost({ baseFee, perKm, perKg, km, weightKg });
  const floor = Number(minFee) || 0;
  return Math.max(total, floor);
}

export function buyerDeliveryCost({ baseFee, perKm, perKg, km, weightKg }) {
  const base = Number(baseFee) || 0;
  const rate = Number(perKm) || 0;
  const weightRate = Number(perKg) || 0;
  const distance = Number(km) || 0;
  const weight = Number(weightKg) || 0;
  // The journey is charged once per shop, however many things are in the box;
  // weight is charged per item, which is what makes a heavy order cost more.
  return base + distance * rate + weight * weightRate;
}

export function deliveryCost({ baseFee, perKm, minFee, km }) {
  const base = Number(baseFee) || 0;
  const rate = Number(perKm) || 0;
  const floor = Number(minFee) || 0;
  const distance = Number(km) || 0;
  return Math.max(base + distance * rate, floor);
}
